export default "__VITE_ASSET__7c436848__"